import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { usePopup } from '../../contexts/PopupContext';
import './join-room.css';

function JoinRoom() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [roomInfo, setRoomInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { roomId } = useParams();
  const navigate = useNavigate();
  const { showPopup } = usePopup();
  useEffect(() => {
    const fetchRoomInfo = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/rooms/${roomId}/info`);
        setRoomInfo(response.data);
      } catch (error) {
        console.error('Error fetching room info:', error);
        showPopup({
          type: 'error',
          title: 'Lỗi',
          message: 'Không thể tải thông tin phòng. Phòng có thể không tồn tại.',
          showCancelButton: false
        });
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    fetchRoomInfo();
  }, [roomId, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        showPopup({
          type: 'error',
          title: 'Lỗi',
          message: 'Email không hợp lệ',
          showCancelButton: false
        });
        return;
      }

      await axios.post(`${process.env.REACT_APP_API_URL}/rooms/join`, {
        roomId,
        password,
        email
      });
      localStorage.setItem(`room_${roomId}_verified`, 'true');
      navigate(`/room/${roomId}`);
    } catch (error) {
      showPopup({
        type: 'error',
        title: 'Lỗi',
        message: error.response?.data?.error || 'Có lỗi xảy ra',
        showCancelButton: false
      });
    }
  };

  if (loading) {
    return (
      <div className="join-room-container">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
          <span>Đang tải thông tin phòng...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="join-room-container">
      <div className="join-room-card">
        <div className="join-room-header">
          <h2>Tham gia phòng</h2>
          <p>Nhập thông tin của bạn để tham gia phòng Give Away</p>
        </div>
        
        {roomInfo && (
          <div className="joinroom-stats">
            <div className="joinroom-stat-item">
              <div className="joinroom-stat-icon">
                <i className="fas fa-users"></i>
              </div>
              <div className="joinroom-stat-info">
                <span className="joinroom-stat-value">{roomInfo.participantsCount}</span>
                <span className="joinroom-stat-label">người tham gia</span>
              </div>
            </div>
            <div className="joinroom-stat-divider"></div>
            <div className="joinroom-stat-item">
              <div className="joinroom-stat-icon">
                <i className="fas fa-user-plus"></i>
              </div>
              <div className="joinroom-stat-info">
                <span className="joinroom-stat-value">
                  {roomInfo.maxParticipants - roomInfo.participantsCount}
                </span>
                <span className="joinroom-stat-label">còn trống</span>
              </div>
            </div>
            <div className="joinroom-stat-divider"></div>
            <div className="joinroom-stat-item">
              <div className="joinroom-stat-icon">
                <i className="fas fa-chart-pie"></i>
              </div>
              <div className="joinroom-stat-info">
                <span className="joinroom-stat-value">
                  {Math.round((roomInfo.participantsCount / roomInfo.maxParticipants) * 100)}%
                </span>
                <span className="joinroom-stat-label">đã đầy</span>
              </div>
            </div>
          </div>
        )}
        
        <div className="join-room-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Email của bạn</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Nhập email của bạn..."
                required
              />
              <small className="form-text">
                Email của bạn sẽ hiển thị cho mọi người trong phòng
              </small>
            </div>

            <div className="form-group">
              <label className="form-label">Mật khẩu phòng</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nhập mật khẩu phòng..."
                required
              />
              <small className="form-text">
                Mật khẩu do người tạo phòng cung cấp
              </small>
            </div>

            <button type="submit" className="join-room-btn">
              <i className="fas fa-sign-in-alt"></i>
              Tham gia ngay
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default JoinRoom; 